module.exports = __webpack_public_path__ + "static/duke_zalto-8ab779f7f65d41e9ecffdc3cd8761773.jpg";